import {
	AZURE_SPEECH_CHUNK_MAX_SECONDS_MAX,
	AZURE_SPEECH_CHUNK_MAX_SECONDS_MIN,
	AZURE_SPEECH_FAMILY,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type ChunkBoundShape = {
	readonly family: string | null;
};

/** Only active for the Azure Speech family: empty means "the server's own value", else a whole number of seconds in its bound. */
function isAzureSpeechChunkMaxSecondsValid<T extends ChunkBoundShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || value === '') {
		return true;
	}

	const seconds = Number(value);

	return (
		Number.isInteger(seconds) &&
		seconds >= AZURE_SPEECH_CHUNK_MAX_SECONDS_MIN &&
		seconds <= AZURE_SPEECH_CHUNK_MAX_SECONDS_MAX
	);
}

export default isAzureSpeechChunkMaxSecondsValid;
